export enum AuthStorageEnum {
  token = "token",
  refreshToken = "refreshToken",
  lastPayment = "lastPayment",
  instagramFacebookAccessToken = "instagramFacebookAccessToken",
  facebookAccessToken = "facebookAccessToken",
}